import { render } from "./doctor-addblog.vue?vue&type=template&id=279db726"
import script from "./doctor-addblog.vue?vue&type=script&lang=js"
export * from "./doctor-addblog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__